export default __webpack_public_path__ + "static/media/impedelife2.4b87eddc.png";